import { useEffect, useState, useMemo } from 'react'
import { Avatar } from 'src/@/components/ui/avatar'
import { Button } from 'src/@/components/ui/button'
import { Dialog, DialogContent, DialogTrigger } from 'src/@/components/ui/dialog'
import Scrollbar from 'src/components/Scrollbar'
import classNames from 'src/utils/classNames'
import Iconify from 'src/components/Iconify';
import { Input } from 'src/@/components/ui/input'
import { useSelector } from 'src/redux/store'
import { useDispatch } from 'react-redux'
import { getChatInternoBuscarContatos } from 'src/redux/slices/staff'
import useAuth from 'src/hooks/useAuth'
import { RowInput } from 'src/components/forms/RowInput'

const NewChat = ({ isEdit, icon }) => {
    const dispatch = useDispatch()
    const { cliente, user } = useAuth();
    const [open, setOpen] = useState(false)
    const [selectedContact, setSelectedContact] = useState()
    const [query, setQuery] = useState();
    const [groupName, setGroupName] = useState();
    const { listaContatos, staff } = useSelector((state) => state.staff);


    const contacts = useMemo(() => {
        if (listaContatos) {
            return listaContatos.filter((contact) => {
                if (!query) {
                    return true
                }

                if (contact.nomeFantasia.toLocaleLowerCase().includes(query) || contact.email.toLocaleLowerCase().includes(query)) {
                    return true
                }

                return false
            })
        }
    }, [listaContatos, query]);

    useEffect(() => {
        if (isEdit && staff?.isGroup) {
            setSelectedContact(staff.people)
            setGroupName(staff.title)
        }
    }, [staff])

    const handleDialogClose = () => {
        setOpen(false)
        setSelectedContact([])
    }

    const handleStartNewChat = () => {
        handleDialogClose()
    }

    const handleSave = () => {
        if(selectedContact?.length === 1 && staff.isGroup && isEdit) return alert('O Grupo deve conter mais de uma pessoa');
    }

    const handleInputChange = (value) => {
        setQuery(value)
    }

    const handleSetSelectedContact = (contact) => {

        setSelectedContact((prevSelectedContacts) => {
            if (!Array.isArray(prevSelectedContacts)) {
                prevSelectedContacts = [];
            }

            const contactExists = prevSelectedContacts.some(
                (c) => c._id === contact._id,
            );

            if (contactExists) {
                return prevSelectedContacts.filter((c) => c._id !== contact._id);
            } else {
                return [...prevSelectedContacts, contact];
            }
        });
    };

    return (
        <Dialog
            open={open}
            onOpenChange={setOpen}

        // onOpenChange={handleDialogClose}
        >
            <DialogTrigger asChild>
                {isEdit ? (
                    <Button
                        size="icon"
                        variant="outline"
                        onClick={() => {
                            setOpen(true);
                            dispatch(getChatInternoBuscarContatos(cliente?._id))
                        }}
                    >
                        <Iconify icon="ic:baseline-edit" />
                    </Button>
                ) : (
                    icon ? (
                        <Button
                            className="flex items-center gap-2 h-7 bg-slate-700"
                            onClick={() => {
                                setOpen(true);
                                dispatch(getChatInternoBuscarContatos(cliente?._id))
                            }}
                        >
                            <Iconify icon="fluent:chat-add-24-regular" />
                            Novo chat
                        </Button>
                    ) : (
                        <Button
                            className="w-full"
                            onClick={() => {
                                setOpen(true);
                                dispatch(getChatInternoBuscarContatos(cliente?._id))
                            }}
                        >
                            Novo chat
                        </Button>
                    )

                )}

            </DialogTrigger>
            <DialogContent>
                {contacts && (
                    <div className='mt-6'>
                        <div className="text-center mb-6">
                            <p>
                                Pesquise e selecione os contatos para criar um chat ou grupo
                            </p>
                        </div>
                        <Input
                            placeholder="Procurar..."
                            type="text"
                            size="sm"
                            prefix={<Iconify icon="ic:baseline-search" className="text-lg" />}
                            onChange={(e) => handleInputChange(e.target.value)}
                        />
                        <div className="mt-4">

                            <div className="mb-6">
                                <Scrollbar
                                    className={classNames(
                                        'overflow-y-auto h-80',
                                    )}
                                >
                                    <div className="h-full pr-3 flex flex-col gap-2">
                                        {contacts.map((contact) => (
                                            <div
                                                key={contact._id}
                                                className={classNames(
                                                    'p-3 rounded-lg flex items-center justify-between cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700',
                                                    selectedContact?.some((item) => item._id === contact._id) &&
                                                    'bg-violet-100 dark:bg-gray-700',
                                                    contact._id === user._id && 'cursor-not-allowed opacity-50'
                                                )}
                                                role="button"
                                                onClick={() => {
                                                    if (contact._id === user.id && isEdit) {
                                                        console.log('Você não pode adicionar ou remover a si mesmo');
                                                        return;
                                                    }
               
                                                    handleSetSelectedContact(contact);
                                                }}
                                            >
                                                <div className="flex items-center gap-2">
                                                    <div>
                                                        <p className="text-sm font-bold">
                                                            {contact.nomeFantasia}
                                                        </p>
                                                        <p className='text-xs'>{contact.email}</p>
                                                    </div>
                                                </div>
                                                {selectedContact?.some((item) => item._id === contact._id) && (
                                                    <Iconify
                                                        icon="material-symbols:check"
                                                        className="text-2xl text-primary"
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </Scrollbar>
                                {selectedContact?.length > 1 && (
                                    <div className='mt-6'>
                                        <RowInput
                                            label="Nome do grupo"
                                            input={<Input
                                                placeholder="Dê um nome ao grupo..."
                                                type="text"
                                                value={groupName}
                                                size="sm"
                                                prefix={<Iconify icon="ic:baseline-search" className="text-lg" />}
                                                onChange={(e) => setGroupName(e.target.value)}
                                            />}
                                        />
                                    </div>
                                )}

                            </div>

                            {isEdit ? (
                                <Button
                                    disabled={selectedContact?.length === 0 || (selectedContact?.length > 1 && !groupName)}
                                    className="w-full"
                                    onClick={handleSave}
                                >
                                    {selectedContact?.length > 1
                                        ? 'Atualizar Grupo'
                                        : 'Atualizar chat'}
                                </Button>
                            ) : (
                                <Button
                                    disabled={selectedContact?.length === 0 || (selectedContact?.length > 1 && !groupName)}
                                    className="w-full"
                                    onClick={handleStartNewChat}
                                >
                                    {selectedContact?.length > 1
                                        ? 'Criar Grupo'
                                        : 'Criar chat'}
                                </Button>
                            )}




                        </div>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default NewChat
